import React, { useEffect } from 'react';
import { useNavigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const Admin = () => {
  const { checkPermission } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    // Only redirect if we're on the base /admin path
    if (location.pathname === '/admin') {
      // Check permissions and redirect to the first available admin section
      if (checkPermission('View Users')) {
        navigate('/admin/users');
      } else if (checkPermission('View Groups')) {
        navigate('/admin/groups');
      } else if (checkPermission('View Forms')) {
        navigate('/admin/forms');
      } else if (checkPermission('View Admin Settings')) {
        // Check admin settings submenu permissions
        if (checkPermission('View Client Types')) {
          navigate('/admin/settings/client-types');
        } else if (checkPermission('View Products')) {
          navigate('/admin/settings/products');
        } else if (checkPermission('View Upload Fields')) {
          navigate('/admin/settings/upload-fields');
        } else if (checkPermission('View Verification Types')) {
          navigate('/admin/settings/verification-types');
        } else if (checkPermission('View Email Gateways')) {
          navigate('/admin/settings/email-gateways');
        } else if (checkPermission('View Invoice Settings')) {
          navigate('/admin/settings/invoice-settings');
        }
      } else {
        // If no permissions, redirect to dashboard
        navigate('/dashboard');
      }
    }
  }, [checkPermission, navigate, location.pathname]);

  return <Outlet />;
};

export default Admin; 